import calendarGif from "../../../assets/icons/calendar.gif";
import { products } from "../../../constants/products";
import { UpsellCardBase } from "../../../components/UpsellCardBase";

export const VisitationScheduleUpsellCard: React.FC = ({}) => {
  const key = "visitation_schedule_tracker";
  const product = products[key];
  if (!product) return null;

  return (
    <UpsellCardBase
      productKey={key}
      title="Visitation Schedule Tracker"
      description="Stay organized and on top of your visitation schedule with ease. Our tools make it easy to document visitations, set reminders, and keep a clear record for court or personal use."
      imageSrc={calendarGif}
      price={product.price}
    />
  );
};
